export const url ="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/"
export const MenuUrl="https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/"

const array= [
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/rtwoqdbuozs6nnhahcoe",
    name:"KFC",
    ratings:"4.8",
    types:"biryani,non-veg,italian,..",
    place:"Hebbal"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/0f50af8e3451e5f9668c03d7e8320db8",
    name:"Five star",
    ratings:"4.1",
    types:"biryani,non-veg,italian,..",
    place:"vijayNagar"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/xvfowmlhv5eoq2na8ac4",
    name:"seven star",
    ratings:"3.7",
    types:"biryani,non-veg,italian,..",
    place:"Chittoor"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/4e0f25ce60f3ad59d5d729f689810bb2",
    name:"Maa Reastarent",
    ratings:"3.9",
    types:"biryani,non-veg,italian,..",
    place:"Pallipat"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/t6el6gy2ohwkzlsiopnu",
    name:"Hotel PubG",
    ratings:"4.0",
    types:"biryani,non-veg,italian,..",
    place:"Tin Factory"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660,e_grayscale/zowfi5sca9i8e57u2vdy",
    name:"Leo ",
    ratings:"4.9",
    types:"biryani,non-veg,italian,..",
    place:"Sanjay Nagar"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/546519962759e593c86b1a6ab7afc614",
     name:"Kateezza",
    ratings:"4.3",
    types:"biryani,non-veg,italian,..",
    place:"MG Road"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/4bff6a8c054deafb77eeec0236fcc83a",
     name:"Biryani House",
    ratings:"3.5",
    types:"biryani,non-veg,italian,..",
    place:"kotagallu"
},
{
    imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/rtwoqdbuozs6nnhahcoe",
    name:"KFC",
    ratings:"4.8",
    types:"biryani,non-veg,italian,..",
    place:"Kansar"
},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/jkijpakmvkfeavdg5lsf",
  name:"Dominos table-1",
  ratings:"4.4",
  types:"biryani,non-veg,italian,..",
  place:"chittor"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/vnibkfc9ne5ngnxrugol",
  name:"Bawachi",
  ratings:"4.3",
  types:"pizza,burger,paasta..",
  place:"k.nagar"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/jexlrtyubi8oly2wdres",
  name:"Nayudu ragi hotel",
  ratings:"4.1",
  types:"rice,sambar,ect,..",
  place:"narayanavanam"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/zx60dfxxoqvrfzf0u2op",
  name:"prasad",
  ratings:"4.1",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"kadapa"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/925577fb639bf773f1f45f55b0150c09",
  name:"bodhan",
  ratings:"3.2",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"tirupati"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/hto9q7qsdysrrozveusz",
  name:"hari's",
  ratings:"4.1",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"g.d.nellore"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660,e_grayscale/ti4kkoycmdxukdnsoqfm",
  name:"ganesh's",
  ratings:"4.4",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"g.n.kandriga"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/kwwqizr70bqa4pxvwebp",
  name:"five start",
  ratings:"3.7",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"chintha tooopu"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/p1p8zgrv61njwjlzvzvm",
  name:"dinesh's",
  ratings:"3.9",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"nelavoi"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/zg1txwtdbbhpe6gwcate",
  name:"dany's",
  ratings:"4.2",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"bangloore"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/f8ajwmxuwttizxq8bxow",
  name:"pooja",
  ratings:"3.1",
  types:"biryani,leg-peice,malasa doosa,..",
  place:"chennai"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/2ad34f3e3a6d44601481750769d02577",
  name:"Guru's",
  ratings:"3.5",
  types:"idlty,doosa,chatni..",
  place:"pallipatu"},
  
{
  imgId:"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/yot1aqhzbajr6bevfszb",
  name:"manoj",
  ratings:"3.9",
  types:"idlty,doosa,chatni..",
  place:"palaluattu"},
]
export default array;